(() => {
  if (window.MirumuOtokuBinInitialized) return;
  window.MirumuOtokuBinInitialized = true;

  /*
   * ------------------------------------------------------------
   * おトク便ヘルプ
   * ------------------------------------------------------------
   */

  const closeAll = () => {
    document
      .querySelectorAll('.mirumu-otoku-bin__popup')
      .forEach((popup) => {
        popup.hidden = true;
      });

    document
      .querySelectorAll('.mirumu-otoku-bin__help')
      .forEach((button) => {
        button.setAttribute('aria-expanded', 'false');
      });
  };

  document.addEventListener('click', (event) => {
    const helpButton = event.target.closest(
      '.mirumu-otoku-bin__help'
    );

    if (helpButton) {
      event.preventDefault();
      event.stopPropagation();

      const popupId =
        helpButton.getAttribute('aria-controls');

      const popup =
        document.getElementById(popupId);

      if (!popup) return;

      const shouldOpen = popup.hidden;

      closeAll();

      if (shouldOpen) {
        popup.hidden = false;
        helpButton.setAttribute(
          'aria-expanded',
          'true'
        );
      }

      return;
    }

    const closeButton = event.target.closest(
      '.mirumu-otoku-bin__popup-close'
    );

    if (closeButton) {
      event.preventDefault();
      closeAll();
      return;
    }

    const popup = event.target.closest(
      '.mirumu-otoku-bin__popup'
    );

    if (!popup) {
      closeAll();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeAll();
    }
  });


  /*
   * ------------------------------------------------------------
   * バリエーション変更時のおトク便表示更新
   * ------------------------------------------------------------
   */

  const updateOtokuBin = (root, variantId) => {
    if (!root || !variantId) return;

    const dataElement = root.querySelector(
      '[data-mirumu-otoku-variant-data]'
    );

    if (!dataElement) return;

    let variants = [];

    try {
      variants = JSON.parse(
        dataElement.textContent
      );
    } catch (error) {
      console.error(
        'MIRUMU おトク便: variant data parse error',
        error
      );
      return;
    }

    const variantData = variants.find(
      (item) =>
        String(item.id) === String(variantId)
    );

    if (!variantData) return;

    const regularPrice = root.querySelector(
      '.mirumu-otoku-bin__regular-price'
    );

    const comparePrice = root.querySelector(
      '.mirumu-otoku-bin__compare-price'
    );

    const salePrice = root.querySelector(
      '.mirumu-otoku-bin__sale-price'
    );

    const discount = root.querySelector(
      '.mirumu-otoku-bin__discount'
    );

    const regularRadio = root.querySelector(
      '[data-mirumu-purchase-option="regular"]'
    );

    const otokuRadio = root.querySelector(
      '[data-mirumu-purchase-option="otoku"]'
    );

    if (regularPrice) {
      regularPrice.textContent =
        variantData.regularPrice;
    }

    if (comparePrice) {
      comparePrice.textContent =
        variantData.regularPrice;
    }

    if (
      variantData.otokuPrice &&
      variantData.sellingPlanId
    ) {
      if (salePrice) {
        salePrice.textContent =
          variantData.otokuPrice;
      }

      if (discount) {
        discount.textContent =
          `${variantData.discountPercent}%OFF`;
      }

      if (otokuRadio) {
        otokuRadio.value =
          variantData.sellingPlanId;

        otokuRadio.disabled = false;
      }
    } else {
      /*
       * 万が一このvariantに
       * おトク便allocationが無い場合
       */
      if (otokuRadio) {
        otokuRadio.disabled = true;

        if (otokuRadio.checked) {
          if (regularRadio) {
            regularRadio.checked = true;

            regularRadio.dispatchEvent(
              new Event('change', {
                bubbles: true,
              })
            );
          }
        }
      }
    }
  };


  /*
   * MIRUMUテーマがvariant変更時に発火するイベント
   */
  document.addEventListener(
    'theme:variant:change',
    (event) => {
      const variant =
        event.detail?.variant;

      if (!variant?.id) return;

      const eventScope =
        event.target instanceof Element
          ? event.target
          : document;

      const roots =
        eventScope.querySelectorAll(
          '.mirumu-otoku-bin'
        );

      if (roots.length > 0) {
        roots.forEach((root) => {
          updateOtokuBin(
            root,
            variant.id
          );
        });

        return;
      }

      /*
       * 念のためscope内で取得できなかった場合
       */
      document
        .querySelectorAll(
          '.mirumu-otoku-bin'
        )
        .forEach((root) => {
          updateOtokuBin(
            root,
            variant.id
          );
        });
    }
  );
})();